export function getSearchLabelForCustomers(customers: any[]) {
	const customerSelectItemsUnique = [...new Set(customers)];
	return customerSelectItemsUnique.map((customer) => getCustomerSearchLabel(customer)).filter((label) => !!label);
}

export function getCustomerSearchLabel(customer: any) {
	if (!customer) {
		return {};
	}

	// Extract customer details
	const name = getCustomerName(customer);
	const phone = getCustomerPhone(customer);
	const email = getCustomerEmail(customer);

	// Build search label from available details
	const searchLabel = [name, phone?.replaceAll(" ", ""), email].filter(Boolean).join(" ").trim();

	return searchLabel ? { ...customer, name, phone, email, searchLabel } : undefined;
}

function getCustomerName(customer: any): string | null {
	const nameParts = [];
	if (customer.firstname) {
		nameParts.push(customer.firstname);
	}
	if (customer.lastname) {
		nameParts.push(customer.lastname);
	}
	return nameParts.length > 0 ? nameParts.join(" ").trim() : null;
}

function getCustomerPhone(customer: any): string | null {
	return customer.PhoneNumbers?.[0]?.phoneNumber || null;
}

function getCustomerEmail(customer: any): string | null {
	return customer.EmailAddresses?.[0]?.emailAddress || null;
}

export function getCustomerDisplayName(customer: any): string {
	return getCustomerName(customer) || getCustomerPhone(customer) || getCustomerEmail(customer) || "";
}

export function getCustomerDisplayNames(customers: any[]): string {
	return customers
		.map((customer) => getCustomerDisplayName(customer))
		.filter(Boolean)
		.join(", ");
}
